
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.75 1.17a2.498 2.498 0 012.497-.002l5.836 3.335c.315.182.58.426.784.712a.792.792 0 01.205.341c.169.34.26.718.261 1.11v6.668c0 .892-.477 1.717-1.253 2.165l-5.83 3.331a2.5 2.5 0 01-.853.303.836.836 0 01-.793 0 2.478 2.478 0 01-.85-.301l-5.837-3.335a2.5 2.5 0 01-1.25-2.164V6.666c0-.393.093-.772.262-1.112a.827.827 0 01.206-.343c.204-.284.468-.527.782-.708zM2.333 7.114v6.218c0 .298.16.573.414.72l5.42 3.096v-6.66zm13.334 0l-5.834 3.374v6.66l5.417-3.095a.833.833 0 00.41-.61l.007-.11zm-6.25-4.5a.835.835 0 00-.837.001L3.2 5.69 9 9.045l5.8-3.355z","fill-rule":"evenodd"}})])
          )
        }
      }
    